// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1848":"3b4a735e","5597":"2bdb13c5","6619":"3b4a735e","9814":"4f69a325"}[chunkId] + ".chunk.css";
};